export default __webpack_public_path__ + "hubspot.acdf6bdf.png";